<template>
    <section>
        <contact-campaigns-stealth-goal-achieved :goal-achieved-list="contactFunnel.goalAchievedList" />
        <contact-campaigns-stealth-flow-recipient :flow-recipient-list="contactFunnel.flowRecipientList" />
        <contact-campaigns-stealth-processed-flow-item :processed-flow-item-list="contactFunnel.processedFlowItemList" />
        <contact-campaigns-stealth-queued-flow-item :queued-flow-item-list="contactFunnel.queuedFlowItemList" />
    </section>
</template>
<script>
import ContactCampaignsStealthGoalAchieved from './ContactCampaignsStealthGoalAchieved.vue';
import ContactCampaignsStealthFlowRecipient from './ContactCampaignsStealthFlowRecipient.vue';
import ContactCampaignsStealthProcessedFlowItem from './ContactCampaignsStealthProcessedFlowItem.vue';
import ContactCampaignsStealthQueuedFlowItem from './ContactCampaignsStealthQueuedFlowItem.vue';
import axios from 'axios';

export default {
    components: {
        ContactCampaignsStealthGoalAchieved,
        ContactCampaignsStealthFlowRecipient,
        ContactCampaignsStealthProcessedFlowItem,
        ContactCampaignsStealthQueuedFlowItem,
    },

    props: {
        contact: Object,
    },

    data() {
        return {
            contactFunnel: {
                goalAchievedList: [],
                flowRecipientList: [],
                processedFlowItemList: [],
                queuedFlowItemList: [],
            },
        };
    },

    created() {
        this.loadContactFunnel();
    },

    methods: {
        async loadContactFunnel() {
            try {
                const response = await axios.get(`/app/funnel/contactStealthTab/${this.contact.id}`);

                this.contactFunnel.goalAchievedList = response?.data?.goalAchievedList;
                this.contactFunnel.flowRecipientList = response?.data?.flowRecipientList;
                this.contactFunnel.processedFlowItemList = response?.data?.processedFlowItemList;
                this.contactFunnel.queuedFlowItemList = response?.data?.queuedFlowItemList;
            } catch (error) {
                this.$error({ message: 'error occurred while loading campaign stealth' });
            }
        },
    },
};
</script>
<style scoped>

</style>
